import { QuestionComponent } from 'app/models/questions/QuestionComponent'
import { RadioComponent } from 'app/modules/survey/survey-viewer/survey-question/types/radio/radio.component'
import { requireSelectionOnEachMatrixRow } from 'app/form-validators/RequireSelectionOnEachMatrixRowValidator'
import { Matrix } from 'app/models/questions/Matrix'
import { UntypedFormGroup } from '@angular/forms'

export class Radio extends Matrix {
  getDisplayComponent() {
    return new QuestionComponent(RadioComponent, this)
  }

  fillFormWithDummyAnswer(surveyForm) {
    this.resetForm(surveyForm)

    this.fillRandomControl(surveyForm)
  }

  buildFormGroupValidators() {
    return this.isOptional ? [] : [requireSelectionOnEachMatrixRow(this)]
  }

  applyMaxAnswers(surveyForm: UntypedFormGroup) {
    return this.limitAnswersAmount;
  }
}
